// config/wagmi.ts
import { http } from 'wagmi'
import { bsc, base, mainnet, xLayer, polygon, arbitrum, bscTestnet, robinhood, arc } from 'wagmi/chains'
import { defineChain } from 'viem';
import { RPCLIST } from '@/config'
import { ChainIdConfigType } from '@/store/type';
import { getDefaultConfig } from '@rainbow-me/rainbowkit'
const projectId = 'e53f0581a14925491c1dd1acdcbc8384'
export const XLayer = defineChain({
    ...xLayer,
    iconUrl: 'images/xlayer.svg',
});

export const Robinhood = defineChain({
    ...robinhood,
    iconUrl: '/images/Robinhood.png',
});
// 🆕 导出 RPC URLs 映射（与 transports 保持一致）
export const RPC_URLS: Record<number, string[]> = transformRpcList(RPCLIST)

export const Arc = defineChain({
    ...arc,
    contracts: {
        ...arc.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
    },
    blockExplorers: {
        default: {
            name: 'ArcScan',
            url: 'https://arc-scan.org/',
            apiUrl: 'https://api.arc-scan.org/api',
        },
    },
})
export const chains = [mainnet, Robinhood, bsc, bscTestnet, arbitrum, base, polygon, XLayer
    // , Arc
] as const
export const ChainIdConfig: ChainIdConfigType[] = chains.map((c) => ({
    label: c.name,
    id: c.id,
}))

export const wagmiConfig = getDefaultConfig({
    appName: 'GTokenTool',
    projectId,
    chains: chains,
    transports: {
        [bsc.id]: http(RPC_URLS[bsc.id]?.[0]),
        [mainnet.id]: http(RPC_URLS[mainnet.id]?.[0]),
        [base.id]: http(RPC_URLS[base.id]?.[0]),
        [XLayer.id]: http(RPC_URLS[XLayer.id]?.[0]),
        [Robinhood.id]: http(RPC_URLS[Robinhood.id]?.[0]),
        [polygon.id]: http(RPC_URLS[polygon.id]?.[0]),
        [arbitrum.id]: http(RPC_URLS[arbitrum.id]?.[0]),
        [bscTestnet.id]: http(RPC_URLS[bscTestnet.id]?.[0]),
        // [Arc.id]: http(RPC_URLS[Arc.id]?.[0]),
    },
    ssr: true
})


function transformRpcList(rpcList) {
    const result = {};

    for (const item of rpcList) {
        result[item.id] = item.rpcs;
    }

    return result;
}